import { lazy } from "react";

// const basePath = "";

// Layouts => BlankLayout - SideBarLayout

const routes = [
  {
    path: "/",
    exact: true,
    component: lazy(() => import("../pages/login")),
    layout: "BlankLayout",
  },
  {
    path: "/work",
    exact: true,
    component: lazy(() => import("../pages/work")),
    layout: "SideBarLayout",
  },
  {
    path: "/statistics",
    exact: true,
    component: lazy(() => import("../pages/statistics")),
    layout: "SideBarLayout",
  },
  {
    path: "/financial",
    exact: true,
    component: lazy(() => import("../pages/financial")),
    layout: "SideBarLayout",
  },
  {
    path: "/weekly",
    exact: true,
    component: lazy(() => import("../pages/weekly")),
    layout: "SideBarLayout",
  },
  {
    path: "/vacation",
    exact: true,
    component: lazy(() => import("../pages/vacation")),
    layout: "SideBarLayout",
  },
  {
    path: "/more",
    exact: true,
    component: lazy(() => import("../pages/more")),
    layout: "SideBarLayout",
  },
  {
    path: "/test",
    exact: true,
    component: lazy(() => import("../pages/test/Test")),
    layout: "SideBarLayout",
  },
];

export default routes;
